export const displayPayButton = (currentTab, userRole, t) => {
  if (currentTab === 'card') {
    return t('rewards-gift:addFunds.payButton')
  }

  if (userRole === 'PropertyManager') {
    return t('rewards-gift:addFunds.sendRequestButton')
  }

  return t('rewards-gift:addFunds.payNowButton')
}

export function isCurrentStepInvoice(currentTab) {
  return currentTab === 'invoice'
}

export function isCurrentStepCard(currentTab) {
  return currentTab === 'card'
}

export const calculateConvenienceFee = (amount, feePercentage) => {
  if (!amount) {
    return 0
  }
  return parseFloat((amount * feePercentage) / 100).toFixed(2)
}
